import { render } from "./Infografis.vue?vue&type=template&id=a6affc9a"
import script from "./Infografis.vue?vue&type=script&lang=js"
export * from "./Infografis.vue?vue&type=script&lang=js"

import "./Infografis.vue?vue&type=style&index=0&id=a6affc9a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__